import axios from "axios";

const client = axios.create({
    withCredentials: true
 });
 

export const BASE_API = process.env.REACT_APP_BASE_API_URL;
export const USERS_API = `${BASE_API}/api/users`;

export interface User {
    _id: string; username: string; password: string; role: string;
    firstName: string, lastName: string
};

export const signin = async (credentials: User) => {
    const response = await client.post(`${USERS_API}/signin`, credentials);
    return response.data;
};


export const profile = async () => {
    const response = await client.post(`${USERS_API}/profile`);
    return response.data;
}

export const updateUser = async (user: any) => {
    const response = await client.put(`${USERS_API}/${user._id}`, user);
    return response.data;
};

export const findAllUsers = async () => {
    const response = await client.get(`${USERS_API}`)
    return response.data;
}

export const createUser = async (user: any) => {
    const response = await client.post(`${USERS_API}`, user);
    return response.data;
}

export const deleteUser = async (user: any) => {
    const response = await client.delete(
        `${USERS_API}/${user._id}`);
    return response.data;
};

export const signup = async (user: any) => {
    const response = await client.post(`${USERS_API}/signup`, user);
    return response.data;
};

export const signout = async () => {
    const response = await client.post(`${USERS_API}/signout`);
    return response.data;
  };
  
